module.exports = __webpack_public_path__ + "static/img/my-esim.86c0751.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mine/my-esim.png
// module id = Bct+
// module chunks = 1